import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import DeleteFileIcon from '../graphics/deleteFileIcon';

const DoxExplorerConfirmRename = ({ documentId, fileList, errorStatus, onCanSave, onNewFileName }) => {
    const translateString = useTranslationContext();
    const [fileType, setFileType] = useState('')
    const [originalFilename, setOriginalFilename] = useState('')
    const [newFilename, setNewFilename] = useState('')

    useEffect(() => {
        let file = fileList.find(x => x.documentId === documentId)
        if (file) {
            if (file.fileName !== originalFilename) {
                setOriginalFilename(file.fileName)
                setNewFilename(file.fileName)
                setFileType(file.fileType)
            }
        }
    }, [fileList, documentId, originalFilename, setOriginalFilename, setNewFilename, setFileType])

    useEffect(() => {
        onCanSave(newFilename && newFilename !== originalFilename)
        onNewFileName(newFilename)
    }, [onCanSave, newFilename, originalFilename])

    return (
        <div className='is-flex is-flex-direction-column is-align-items-center is-justify-content-center doxe-confirm'>
            <DeleteFileIcon color='#89D49F' />
            <div className='p1'>{translateString('Dox.DocumentExplorer.RenamePrompt', { FileName: originalFilename + fileType })}</div>
            <div>
                <input type='text' id='doxe-rename-input' value={newFilename}
                    onChange={(ev) => setNewFilename(ev.target.value || '')} />
            </div>
            {errorStatus === 'fail' &&
                <div className='doxe-red'>{translateString('Dox.DocumentExplorer.Errors.Transient')}</div>
            }
            {errorStatus === 'duplicate' &&
                <div className='doxe-red'>{translateString('Dox.DocumentExplorer.NameExists')}</div>
            }
        </div>
    )
}

DoxExplorerConfirmRename.propTypes = {
    documentId: PropTypes.string.isRequired,
    fileList: PropTypes.arrayOf(PropTypes.object).isRequired,
    errorStatus: PropTypes.string,
    onCanSave: PropTypes.func.isRequired,
    onNewFileName: PropTypes.func.isRequired
}   

export default DoxExplorerConfirmRename;